import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5ef571a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Dashboard-Jobs" }
const _hoisted_2 = { class: "Dashboard-Jobs--inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/jobs/complete-profile.png 1x, /dev/jobs/complete-profile@2x.png 2x" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/dev/jobs/complete-profile.png",
    alt: "program started image"
  })
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/jobs/no-jobs.png 1x, /dev/jobs/no-jobs@2x.png 2x" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/dev/jobs/no-jobs.png",
    alt: "program started image"
  })
], -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "Dashboard-Jobs_List" }
const _hoisted_8 = { class: "center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_DashboardJobsCard = _resolveComponent("DashboardJobsCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state === 'no-jobs' || _ctx.state === 'complete-profile')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["Dashboard-Jobs_Background", [_ctx.state]])
          }, [
            (_ctx.state === 'complete-profile')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createElementVNode("p", {
                    innerHTML: _ctx.$t('dashboard.complete_profile_description')
                  }, null, 8, _hoisted_4),
                  _createVNode(_component_ButtonHover, {
                    to: "/my-profile/edit",
                    class: "Header__right-btn button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.complete_profile')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5,
                  _createElementVNode("p", {
                    class: "",
                    innerHTML: _ctx.$t('dashboard.job_board_description')
                  }, null, 8, _hoisted_6),
                  _createVNode(_component_ButtonHover, {
                    to: "/job-board",
                    class: "Header__right-btn button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.job_board')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
          ], 2))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                return (_openBlock(), _createBlock(_component_DashboardJobsCard, {
                  job: job,
                  key: 'dashboard-job-' + job.slug
                }, null, 8, ["job"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ButtonHover, {
                to: "/job-board",
                class: "Header__right-btn button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('dashboard.job_board')), 1)
                ]),
                _: 1
              })
            ])
          ], 64))
    ])
  ]))
}